<template>
	<div class="model1">
		<div class="m1_top_box">
			<h5>
				<img src="../../assets/main/title_icon.jpg" alt="" />{{
					titleCountry
				}}碳市场排放权配额成交量
			</h5>
			<h5>
				<img src="../../assets/main/title_icon.jpg" alt="" />{{
					titleCountry
				}}碳市场排放权配额成交价
			</h5>
			<div class="m1_echarts_box">
				<div class="m1_echarts1" id="m1_echarts1"></div>
				<div class="m1_echarts2" id="m1_echarts2"></div>
			</div>
		</div>
		<!-- 文章列表部分 -->
		<div class="m1_info_box">
			<div class="m1_search_box">
				<el-date-picker
					@change="changeDateFn"
					style="width:250px;border: 1px solid #F3F3F3;margin-left:12px;"
					size="large"
					v-model="dateRaneg"
					unlink-panels
					type="daterange"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
				>
				</el-date-picker>
				<div @click="downloadTable" class="m1_download_data">
					导出数据
				</div>
			</div>
			<ul class="m1_info_ul">
				<el-table
					v-loading="loading"
					element-loading-text="加载中"
					:empty-text="loading == true ? '加载中' : '暂无数据'"
					:fit="true"
					style="width:100%;margin:20px auto;"
					:data="dataList"
					:header-cell-style="headerCellStyle"
					:row-style="tableRowClassName"
					:cell-style="cellStyle"
					border
				>
					<el-table-column
						v-for="(item, index) in dataList[0]"
						:prop="index"
						:label="item"
						:show-overflow-tooltip="true"
						:sortable="false"
						align="center"
						:key="index"
						:min-width="
							tableColumnWidth[index] < 24
								? tableColumnWidth[index] * 16
								: tableColumnWidth[index] * 8
						"
					>
					</el-table-column>
				</el-table>
				<el-empty
					v-if="dataList.length <= 0 && loading == false"
					description="暂无数据!"
				></el-empty>
				<el-empty
					v-if="loading == true"
					description="加载中!"
				></el-empty>
			</ul>
			<div v-if="currentSource" style="font-size: 14px; float: right;">
				来源：{{ currentSource }}
			</div>
			<div class="pagination_box">
				<el-pagination
					v-if="dataList.length > 0"
					@current-change="handleCurrentChange"
					:current-page="currentPage"
					:page-size="pagesize"
					layout="total, prev, pager, next, jumper"
					:total="total"
				>
				</el-pagination>
			</div>
		</div>
	</div>
</template>
<script>
import api from '@/../static/common/api/api.js';
import magic from '@/../static/common/magic.js';
import $ from 'jquery';
import echarts from 'echarts';
import axios from 'axios';

export default {
	// 能源展示数据--全国各省
	props: ['currentChoose', 'currentSource'],
	components: {},
	data() {
		return {
			dateRaneg: [], //日期
			startDate: '', //日历开始时间
			endDate: '', //日历结束时间
			dataType: '', //时间选项 0是 一周 1 是一个月 2 是一年 不限 ''
			currentPage: 1, //当前页
			total: 0, //总页数
			pagesize: 10, //每页条数
			dataList: [], //文章列表数据
			tableColumnWidth: [], //表格各个列最大宽度
			loading: false, //表格加载
			maps: {
				bigNum: 0, //当前地图数据里的最大值
			},
			titleCountry: '',
		};
	},
	watch: {
		currentChoose(val) {
			this.currentPage = 1;
			this.fetchDataList(val); //获取文章列表
			this.echartsfn1();
			this.echartsfn2();
		},
		//时间段清零函数
		dateRaneg(val) {
			if (val == null) {
				this.startDate = '';
				this.endDate = '';

				this.currentPage = 1;
				this.fetchDataList(this.currentChoose);
			}
			//console.log(val,'test');
		},
	},
	computed: {},
	created() {
		$('.el-range-editor.el-input__inner').css(
			'border',
			'1px solid #F3F3F3!important'
		);
	},
	mounted() {
		setTimeout(() => {
			$('.el-range-editor--small.el-input__inner').css(
				'border',
				'1px solid #F3F3F3'
			);
			$('.el-pagination__editor.el-input .el-input__inner').css(
				'border',
				'1px solid #E6E6E6!important'
			);
			$('.el-range-editor.el-input__inner').css(
				'border',
				'1px solid #F3F3F3!important'
			);
		}, 2000);

		this.fetchDataList(this.currentChoose);

		this.echartsfn1();
		this.echartsfn2();
	},
	methods: {
		//点击下载按钮
		downloadTable() {
			let _this = this;
			let params = {
				indexId: _this.currentChoose,
				pagesize: this.pagesize,
				curpage: this.currentPage,
				start: this.startDate,
				end: this.endDate,
				type: '0',
			};

			axios({
				method: 'post',
				url: window.normalUrl + '/down/downTranData', // 请求地址
				data: params,
				responseType: 'arraybuffer',
				observe: 'response',
			}).then((res) => {
				const fileName = decodeURIComponent(
					res.headers['content-disposition']
						.split(';')[1]
						.split('=')[1]
				);
				let blob = new Blob([res.data], {
					type:
						'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
				});
				// //console.log(decodeURIComponent(res.headers['content-disposition'].split(';')[1].split('=')[1]),'blob');
				if ('download' in document.createElement('a')) {
					// 非IE下载
					const elink = document.createElement('a');
					elink.download = fileName;
					elink.style.display = 'none';
					elink.href = URL.createObjectURL(blob);
					document.body.appendChild(elink);
					elink.click();
					URL.revokeObjectURL(elink.href); // 释放URL 对象
					document.body.removeChild(elink);
				} else {
					// IE10+下载
					navigator.msSaveBlob(blob, fileName);
					// navigator.msSaveBlob(blob);
				}
			});
		},
		//table的单元格样式
		cellStyle(row, column, rowIndex, columnIndex) {
			//styles
			let _this = this;
			if (row.rowIndex % 2 == 0 && row.rowIndex > 0) {
				return 'background:#F5F7F5;';
			}
			if (row.rowIndex == 0) {
				return 'color: #333333;font-weight:bold;font-family:Microsoft YaHei;background:#F7F7F7;display:none;';
			}
		},
		//获取表格每一列的文字最大长度
		getMaxTableWidthFn(data) {
			let _this = this;
			let tmpLen = Object.keys(data[0]).length;
			let arr = [];
			for (let i = 0; i < tmpLen; i++) {
				arr.push([]);
			}
			for (let i = 0; i < data.length; i++) {
				for (let item in data[i]) {
					let len = _this.chkstrlen(String(data[i][item]));
					arr[item].push(len);
				}
			}
			_this.tableColumnWidth = [];
			for (let i = 0; i < arr.length; i++) {
				_this.tableColumnWidth.push(Math.max(...arr[i]));
			}
		},
		//判断是否是汉字
		chkstrlen(str) {
			let strlen = 0;
			for (let i = 0; i < str.length; i++) {
				if (str.charCodeAt(i) > 255) {
					//如果是汉字，则字符串长度加2
					strlen += 2;
				} else {
					strlen++;
				}
			}
			return strlen;
		},
		// table表格样式
		headerCellStyle({ row, rowIndex }) {
			return 'background:#F5F7F5;color:#222222;';
		},
		tableRowClassName({ row, rowIndex }) {
			if (rowIndex % 2 == 0) {
				return 'background:#F5F7F5!important;';
			}
			return '';
		},
		// 柱状图1
		echartsfn1() {
			var chartDom = document.getElementById('m1_echarts1');
			var myChart = echarts.init(chartDom);
			var option;

			option = {
				dataZoom: [
					{
						start: 88,
						end: 100,
						height: 16,
					},
				],
				tooltip: {
					show: true,
					trigger: 'item',
					formatter: '{b}： {c}',
				},
				color: ['#42A15B'],
				grid: {
					left: '2%',
					right: '2%',
					bottom: '16%',
					top: '3%',
					containLabel: true,
				},
				xAxis: {
					type: 'category',
					data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
					axisLine: {
						lineStyle: {
							color: '#CCCCCC',
							width: 1, //这里是为了突出显示加上的
						},
					},
					axisLabel: {
						// X轴线 标签修改
						textStyle: {
							color: '#4D4D4D', //坐标值得具体的颜色
						},
					},
					splitLine: {
						show: true, // X轴线 颜色类型的修改
						lineStyle: {
							type: 'dashed',
							color: '#F2F2F2',
						},
					},
				},
				yAxis: {
					type: 'value',
					axisLine: {
						lineStyle: {
							color: '#CCCCCC',
							width: 1, //这里是为了突出显示加上的
						},
					},
					axisLabel: {
						// X轴线 标签修改
						textStyle: {
							color: '#4D4D4D', //坐标值得具体的颜色
						},
					},
					splitLine: {
						show: true, // X轴线 颜色类型的修改
						lineStyle: {
							type: 'dashed',
							color: '#F2F2F2',
						},
					},
				},
				series: [
					{
						data: [120, 200, 150, 80, 70, 110, 130],
						type: 'bar',
						barWidth: 14,
						showBackground: true,
						backgroundStyle: {
							color: 'rgba(180, 180, 180, 0.2)',
						},
					},
				],
			};

			let params = { indexId: this.currentChoose };
			let _this = this;
			api.getGraphData2(params).then((res) => {
				_this.titleCountry = res.data.region;
				option.series[0].data = res.data['xList'];
				option.xAxis.data = res.data['yList'];
				option.tooltip.formatter = '{b}： {c}' + res.data['unitName'];

				option && myChart.setOption(option);
			});
		},
		// 柱状图2
		echartsfn2() {
			var chartDom = document.getElementById('m1_echarts2');
			var myChart = echarts.init(chartDom);
			var option;

			option = {
				grid: {
					left: '2%',
					right: '2%',
					bottom: '16%',
					top: '3%',
					containLabel: true,
				},
				tooltip: {
					trigger: 'axis',
					formatter: function(params) {
						var tipText = '';
						tipText +=
							'<span style="display:block;width:100%;padding:0 10px; margin-bottom:20px;font-size: 14px;font-family: Source Han Sans CN;font-weight: 500;">' +
							params[0].axisValue +
							'</span>';

						for (let index = 0; index < params.length; index++) {
							const element = params[index];
							tipText +=
								'<span style="display:block;width:100%;margin-bottom:15px;padding:0 10px;font-size: 12px;font-family: Source Han Sans CN;font-weight: 500;">' +
								element.marker +
								element.data.region +
								' 成交价：' +
								element.data.value +
								'元/吨';
						}
						return tipText;
					},
				},
				legend: {
					width: 360,
					left: 0,
					// itemGap: 30,
					// orient: 'vertical',
					data: ['Email', 'Union Ads'],
					textStyle: { lineHeight: 10, padding: [0, 15, 0, 10] },
				},
				grid: {
					left: '3%',
					right: '4%',
					bottom: '16%',
					containLabel: true,
				},
				toolbox: {
					feature: {
						// saveAsImage: {}
					},
				},
				xAxis: {
					type: 'category',
					boundaryGap: false,
					data: ['Mon', 'Tue'],
					axisLine: {
						lineStyle: {
							color: '#CCCCCC',
							width: 1, //这里是为了突出显示加上的
						},
					},
					axisLabel: {
						// X轴线 标签修改
						textStyle: {
							color: '#4D4D4D', //坐标值得具体的颜色
						},
					},
					splitLine: {
						show: true, // X轴线 颜色类型的修改
						lineStyle: {
							type: 'dashed',
							color: '#F2F2F2',
						},
					},
				},
				yAxis: {
					type: 'value',
					axisLine: {
						lineStyle: {
							color: '#CCCCCC',
							width: 1, //这里是为了突出显示加上的
						},
					},
					axisLabel: {
						// X轴线 标签修改
						textStyle: {
							color: '#4D4D4D', //坐标值得具体的颜色
						},
					},
					splitLine: {
						show: true, // X轴线 颜色类型的修改
						lineStyle: {
							type: 'dashed',
							color: '#F2F2F2',
						},
					},
				},
				dataZoom: [
					{
						start: 88,
						end: 100,
						height: 16,
					},
				],
				series: [
					{
						name: 'Email1',
						type: 'line',
						stack: 'Total',
						data: [
							{ value: '1', name: 'lisi' },
							{ value: '2', name: 'jack' },
							{ value: '100', name: 'john' },
						],
					},
					{
						name: 'Email2',
						type: 'line',
						stack: 'Total',
						data: [
							{ value: '1', name: 'lisi' },
							{ value: '2', name: 'jack' },
							{ value: '100', name: 'john' },
						],
					},
					{
						name: 'Email3',
						type: 'line',
						stack: 'Total',
						data: [
							{ value: '1', name: 'lisi' },
							{ value: '2', name: 'jack' },
							{ value: '100', name: 'john' },
						],
					},
				],
			};

			let date = new Date();
			let _year = date.getFullYear() + '';
			let _this = this;
			//console.log(_year,'year');
			api.getRegionTransactionData({
				yearDate: _year,
				indexId: _this.currentChoose,
			}).then((res) => {
				let series = res.data.series;
				let legend = res.data.legend;
				let xAxis = res.data.xAxis;
				let series2 = [];

				option.series = [];
				option.legend.data = [];
				option.xAxis.data = [];

				if (series.length > 0) {
					for (let i = 0; i < series.length; i++) {
						series2.push({
							smooth: true, //如果想折线图平滑可以加上这个属性
							name: series[i].name,
							type: 'line',
							// stack: 'Total',
							data: series[i].priceList,
						});
					}
				}

				option.series = series2;

				if (_this.currentChoose == 1) {
					option.legend.data = legend;
				} else {
					option.legend = { show: false };
					option.grid.top = '5%';
				}

				option.xAxis.data = xAxis;
				option && myChart.clear();
				option && myChart.setOption(option);

				//console.log(res.data,'res.data3');
			});
		},
		// 点击日历切换函数
		changeDateFn(res) {
			if (this.dateRaneg.length > 0) {
				let startDate = magic.TimestampToDateTime(res[0]);
				let endDate = magic.TimestampToDateTime(res[1]);

				startDate
					? (this.startDate = startDate.substring(0, 10))
					: (this.startDate = '');
				endDate
					? (this.endDate = endDate.substring(0, 10))
					: (this.endDate = '');

				this.currentPage = 1;
				this.fetchDataList(this.currentChoose);
			}
		},
		//获取表格数据
		fetchDataList(_id) {
			let _this = this;
			//type，0：全国，1：全球
			let params = {
				indexId: _id,
				pagesize: this.pagesize,
				curpage: this.currentPage,
				start: this.startDate,
				end: this.endDate,
				type: '0',
			};
			this.loading = true;
			api.getGraphListData2(params).then((res) => {
				//console.log(res,'list')

				_this.dataList = res.data.rows;
				_this.getMaxTableWidthFn(res.data.rows);
				_this.total = res.data.total;
				setTimeout(() => {
					_this.loading = false;
				}, 100);
			});
		},
		//翻页
		handleCurrentChange(val) {
			this.currentPage = val;
			this.fetchDataList(this.currentChoose);
		},
	},
	filters: {
		subData1: function(value) {
			return value.substring(0, 7);
		},
		subData2: function(value) {
			return value.substring(8, 10);
		},
	},
};
</script>
<style scoped lang="less">
.model1 {
	width: 890px;
	height: 100%;
	// overflow: hidden;
	padding: 14px 30px;
	background: #fff;
}

.m1_top_box {
	width: 100%;
	// overflow: hidden;
	position: relative;
}

.m1_echarts_box {
	width: 100%;
	// overflow: hidden;
	// margin-top: 85px;
}

.m1_echarts_alert {
	width: 313px;
	height: 196px;
	background: #ffffff;
	border: 1px solid #dbdbdb;
	box-shadow: 0px 0px 27px 0px rgba(190, 193, 189, 0.75);
	border-radius: 2px;
	position: absolute;
	bottom: 0;
	left: 0;
	z-index: 1000;
	// display: none;
}
.m1_echarts_bar_close {
	position: absolute;
	bottom: 181px;
	left: 299px;
	display: block;
	width: 25px;
	height: 25px;
	border: 1px solid #ccc;
	z-index: 200000;
	text-align: center;
	line-height: 26px;
	border-radius: 50%;
	background: #fff;
	cursor: pointer;
}
.m1_top_box {
	width: 100%;
	// overflow: hidden;
}
.m1_top_box h5 {
	width: 415px;
	height: 50px;
	line-height: 50px;
	float: left;
	border-bottom: 1px solid #e7ede5;
	font-size: 16px;
	font-family: Source Han Sans CN;
	font-weight: 500;
	color: #222222;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	-o-text-overflow: ellipsis;
}
.m1_top_box h5:first-child {
	margin-right: 60px;
}
.m1_top_box h5 img {
	height: 18px;
	display: inline-block;
	margin-right: 5px;
	vertical-align: middle;
}
.m1_echarts_box {
	width: 100%;
	// overflow: hidden;
	// margin-top: 85px;
}
.m1_echarts1 {
	width: 416px;
	height: 280px;
	float: left;
}
.m1_echarts2 {
	width: 420px;
	height: 280px;
	float: right;
	// z-index: 999;
}
//文章列表部分
.m1_info_box {
	width: 100%;
	overflow: hidden;
	position: relative;
}
.m1_info_box h5 {
	width: 100%;
	height: 70px;
	line-height: 70px;
	border-bottom: 1px solid #e7ede5;
	font-size: 16px;
	font-family: Source Han Sans CN;
	font-weight: 500;
	color: #222222;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	-o-text-overflow: ellipsis;
	margin-top: 30px;
}
.m1_info_box h5 img {
	height: 18px;
	display: inline-block;
	margin-right: 5px;
	vertical-align: middle;
}
// 搜索框部分
.m1_search_box {
	width: 100%;
	line-height: 32px;
	margin-top: 22px;
	overflow: hidden;
}
.m1_download_data {
	width: 100px;
	height: 36px;
	background: #4eac41;
	border-radius: 1px;
	font-size: 12px;
	font-family: Source Han Sans CN;
	font-weight: 500;
	color: #ffffff;
	text-align: center;
	line-height: 36px;
	display: inline-block;
	float: right;
	cursor: pointer;
}

.el-range-editor.el-input__inner {
	border: 1px solid #e7ede5 !important;
}
.m1_info_ul {
	width: 100%;
	overflow: hidden;
	margin-top: 16px;
}

// table样式
.el-table .row_yellow {
	background: #f5f7f5 !important;
}

// 分页
.pagination_box {
	width: 100%;
	overflow: hidden;
	margin-bottom: 70px;
	margin-top: 50px;
	text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/view/trancolumn/mode5.vue